import { render, staticRenderFns } from "./RegisterTeam.vue?vue&type=template&id=42fd856e&scoped=true"
import script from "./RegisterTeam.vue?vue&type=script&lang=js"
export * from "./RegisterTeam.vue?vue&type=script&lang=js"
import style0 from "./RegisterTeam.vue?vue&type=style&index=0&id=42fd856e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42fd856e",
  null
  
)

export default component.exports